import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { AlertEditFormValues } from '@/components/spotter/notificationTab/CustomSensorAlertsSection';

export const useAlertsFromForm = () => {
    const { watch } = useFormContext<AlertEditFormValues>();
    const [thresholdValue, logicalOperator, sensorPosition] = watch([
        'thresholdValue',
        'logicalOperator',
        'sensorPosition',
    ]);

    return useMemo(() => {
        return [
            {
                operator: logicalOperator,
                value: thresholdValue?.length ? Number(thresholdValue) : undefined,
                sensorPosition: sensorPosition?.length ? Number(sensorPosition) : undefined,
            },
        ];
    }, [logicalOperator, thresholdValue, sensorPosition]);
};
